"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* global jQuery, $ */

/* eslint-disable */
var modalDialog = function () {
  return {
    constants: {
      btnRoles: {
        accept: 'accept',
        cancel: 'cancel',
        close: 'close',
        none: 'none'
      },
      btnTitles: {
        accept: 'Принять',
        cancel: 'Отмена',
        close: 'Закрыть'
      },
      btnClasses: {
        accept: '-primary',
        cancel: '',
        close: '-close'
      },
      dataKeys: {
        main: 'modalDialogUserData',
        userContainer: 'modalDialogUserConteiner',
        buttonData: 'modalDialogButtonData'
      }
    },
    busyIndicator: function busyIndicator(visible) {
      var indicator = $('.loader.-global');

      if (visible === undefined || !!visible && indicator.length === 0 || !visible && indicator.length > 0) {
        if (indicator.length > 0) {
          indicator.remove();
          indicator = null;
        } else {
          indicator = $('<div class="loader -global"></div>').appendTo('body');
        }
      }

      return indicator;
    },
    showBaseWnd: function showBaseWnd(options) {
      var settings = $.extend({
        // пользовательский объект, он пробрасывается во все обработчики событий.
        // Предназначен для хранения пользовательской инфы
        userTag: null,
        buttons: null,
        // массив отображаемых кнопок
        inputs: null,
        // массив отображаемых инпутов
        footer: null,
        // свойства футера
        title: '',
        // заголовок окна
        "class": '',
        // дополнительные классы
        isVertical: null,
        // является ли модалка вертикальной
        size: null,
        // размер модалки пока есть big, large
        isCelebrating: null,
        // является ли модалка красивой, поздравительной
        // отображать ли кнопку-крестик в правом верхнем углу
        // (она интерпретируется как this.constants.btnRoles.close)
        showCrossButton: true,
        attrNameFocus: '[data-modalfocus]',
        // строка для поиска элемента, который нужно сфокусировать после отображения окна
        onDrawContent: null,
        // Событие на запрос контента function(sender, userTag)
        onOpen: null,
        // событие окно открывается function(sender, userTag)
        afterOpen: null,
        // событие окно открылось function(sender, userTag)
        onClose: null,
        // событие окно закрывается function(sender, userTag, btnStatus)
        afterClose: null // событие окно закрылось function(sender, userTag, btnStatus)

      }, options);
      var wndData = {
        settings: settings,
        buttons: [],
        inputs: [],
        content: null,
        modalResult: null
      };
      var modalWnd = $("<div class='modal ".concat(settings.isVertical ? '-vertical' : 'fade', " ").concat(settings.size ? '-' + settings.size : '', " ").concat(settings.isCelebrating ? '-celebrating' : '', "' tabindex='-1' role='dialog'>\n                                <div class='modal-dialog' role='document'>\n                                    <div class='modal-content'>\n                                        <div class ='modal-header'>\n                                            ").concat('<div class="modal-title">{0}</div>'.format(settings.title), "\n                                            ").concat(settings.showCrossButton ? '<button type="button" class="btn -close" data-btnrole="{0}"></button>'.format(this.constants.btnRoles.close) : '', "\n                                        </div>\n                                        ").concat('<div class="modal-body{0}">'.format(settings["class"]), "\n                                        </div>\n                                        <div class='modal-footer ").concat(settings.footer && settings.footer.classNames ? settings.footer.classNames : "", "'>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>"));
      var containerBody = modalWnd.find('.modal-body');
      var containerFooter = modalWnd.find('.modal-footer');

      if (settings.inputs && settings.inputs.length > 0) {
        for (var i = 0; i < settings.inputs.length; i += 1) {
          var inputSettings = $.extend({
            // userTag: null,
            id: null,
            placeholder: undefined,
            disabled: false,
            type: 'text',
            title: '' // onChange: null,

          }, settings.inputs[i]);

          if (inputSettings.placeholder === undefined || inputSettings.placeholder === null) {
            inputSettings.placeholder = '';
          }

          var inputMarkup = void 0;

          switch (inputSettings.type) {
            case 'text':
              inputMarkup = "<input ".concat(inputSettings.id ? 'id="' + inputSettings.id + '"' : '', " type='text' \n                                                  placeholder='{0}'\n                                                  class='inp -modal'\n                                                  ").concat(inputSettings.disabled ? 'disabled="disabled"' : '', ">").format(inputSettings.placeholder);
              break;

            case 'checkbox':
              inputMarkup = "<input id='".concat(inputSettings.id, "' type='checkbox' class='checkbox' \n                                                  ").concat(inputSettings.disabled ? 'disabled="disabled"' : '', ">\n                                           <label onclick='setTimeout(disableButton, 250, event)' for='").concat(inputSettings.id, "'>").concat(inputSettings.title, "</label>");
              break;

            case 'radio':
              inputMarkup = "<input id='".concat(inputSettings.id, "' type='radio' class='radio'\n                                                  ").concat(inputSettings.disabled ? 'disabled="disabled"' : '', ">\n                                           <label for='").concat(inputSettings.id, "'>").concat(inputSettings.title, "</label>");
              break;

            default:
              break;
          }

          var inp = $(inputMarkup).appendTo(containerFooter);

          if (inputSettings.type === 'text') {
            containerFooter.addClass('-space-between');
          } // inp.data(this.constants.dataKeys.buttonData, inputSettings);


          wndData.inputs.push(inp);
        }
      }

      if (settings.buttons && settings.buttons.length > 0) {
        for (var _i = 0; _i < settings.buttons.length; _i += 1) {
          var btnSettings = $.extend({
            userTag: null,
            id: null,
            role: this.constants.btnRoles.cancel,
            title: undefined,
            disabled: false,
            primary: false,
            big: false,
            wide: false,
            onClick: null // function(sender, userTag, settings, mainElem)

          }, settings.buttons[_i]);

          if (btnSettings.title === undefined || btnSettings.title === null) {
            btnSettings.title = this.constants.btnTitles[btnSettings.role];
          }

          var btn = $("<button type='button' class='btn {2}' data-btnrole='{1}'>{0}</button>".format(btnSettings.title, btnSettings.role, this.constants.btnClasses[btnSettings.role])).appendTo(containerFooter);

          if (btnSettings.disabled) {
            btn.attr('disabled', true);
          }

          if (btnSettings.primary) {
            btn.addClass('-primary');
          } else {
            btn.addClass('-secondary');
          }

          if (btnSettings.big) {
            btn.addClass('-big');
          } else {
            btn.addClass('-small');
          }

          if (btnSettings.wide) {
            btn.addClass('-wide');
          }

          if (btnSettings.id) {
            btn.attr('id', btnSettings.id);
          }

          btn.data(this.constants.dataKeys.buttonData, btnSettings);
          wndData.buttons.push(btn);
        }
      }

      if ((!settings.buttons || settings.buttons.length === 0) && (!settings.inputs || settings.inputs.length === 0)) {
        containerFooter.hide();
      }

      modalWnd.data(this.constants.dataKeys.main, wndData);

      if (settings.onDrawContent) {
        wndData.content = settings.onDrawContent(modalWnd, settings.userTag);

        if (wndData.content instanceof jQuery) {
          containerBody.append(wndData.content);
        } else {
          containerBody.html(wndData.content);
        }
      }

      modalWnd.find('[data-btnrole]').on('click', {
        wnd: modalWnd,
        wndData: wndData
      }, function (event) {
        var elem = $(event.currentTarget);
        var wnd = event.data.wnd;
        var wndData = event.data.wndData;
        var btnSettings = elem.data(modalDialog.constants.dataKeys.buttonData);
        var doNext = true;

        if (btnSettings && btnSettings.onClick) {
          doNext = btnSettings.onClick(elem, btnSettings.userTag, btnSettings, wnd);
        }

        if (doNext === undefined || doNext === null || doNext) {
          /*
          wndData.modalResult = elem.data("btnrole");
          if (wndData.settings.onClose)
              wndData.settings.onClose(wnd,
                  wndData.settings.userTag, wndData.modalResult);
            event.data.wnd.modal('hide');
          */
          modalDialog.tools.internalClose(wnd, wndData, elem.data('btnrole'));
        }
      });
      modalWnd.on('show.bs.modal', {
        wnd: modalWnd,
        wndData: wndData
      }, function (event) {
        var wnd = event.data.wnd;
        var wndData = event.data.wndData;

        if (wndData.settings.onOpen) {
          wndData.settings.onOpen(modalWnd, wndData.settings.userTag);
        }
      });
      modalWnd.on('shown.bs.modal', {
        wnd: modalWnd,
        wndData: wndData
      }, function (event) {
        var wnd = event.data.wnd;
        var wndData = event.data.wndData;
        var settings = wndData.settings;
        event.data.wnd.find(settings.attrNameFocus).focus();

        if (wndData.settings.afterOpen) {
          wndData.settings.afterOpen(modalWnd, wndData.settings.userTag);
        }
      });
      modalWnd.on('hidden.bs.modal', {
        wnd: modalWnd,
        wndData: wndData
      }, function (event) {
        var wnd = event.data.wnd;
        var wndData = event.data.wndData;

        if (!wndData.modalResult) {
          // закрыли эскейпом либо кликом за пределами окна
          if (wndData.settings.onClose) {
            wndData.settings.onClose(modalWnd, wndData.settings.userTag, wndData.modalResult);
          }
        }
      });
      modalWnd.on('hidden.bs.modal', {
        wnd: modalWnd,
        wndData: wndData
      }, function (event) {
        var wnd = event.data.wnd;
        var wndData = event.data.wndData;

        try {
          if (wndData.settings.afterClose) {
            wndData.settings.afterClose(modalWnd, wndData.settings.userTag, wndData.modalResult);
          }
        } finally {
          if (wndData.settings.isVertical) {
            wnd.addClass('-animate-fadeOutRight'); // to prevent sparking modal close 
            // wait animation execution

            setTimeout(function () {
              wnd.remove();
            }, 1000);
          } else {
            wnd.remove();
          }
        }
      });
      modalWnd.modal('show');
      return modalWnd;
    },
    showInfo: function showInfo(title, content, wndClose, isNotDisplayCancelButton) {
      var baseWnd = this.showBaseWnd({
        userTag: {
          onClose: wndClose,
          content: content
        },
        title: title,
        buttons: !isNotDisplayCancelButton ? [{
          role: this.constants.btnRoles.cancel
        }] : null,
        onClose: function onClose(sender, userTag, btnStatus) {
          if (userTag.onClose) {
            userTag.onClose();
          }
        },
        onDrawContent: function onDrawContent(sender, userTag) {
          return userTag.content;
        }
      });
      return baseWnd;
    },
    showError: function showError(title, content, wndClose) {
      if (content === null || content === undefined) content = 'Произошла непредвиденная ошибка.';
      return this.showInfo(title, content, wndClose);
    },
    tools: {
      buttonsDisabling: function buttonsDisabling(wndObj, buttonRole, disabled) {
        var wndData = wndObj.data(modalDialog.constants.dataKeys.main);

        if (wndData) {
          for (var i = 0; i < wndData.buttons.length; i += 1) {
            if (wndData.buttons[i].data('btnrole') === buttonRole) {
              if (disabled) {
                wndData.buttons[i].attr('disabled', true);
              } else {
                wndData.buttons[i].attr('disabled', false);
              }
            }
          }
        }
      },
      wndClose: function wndClose(wndObj, buttonRole) {
        var wndData = wndObj.data(modalDialog.constants.dataKeys.main);

        if (wndData) {
          modalDialog.tools.internalClose(wndObj, wndData, buttonRole);
        }
      },
      internalClose: function internalClose(wndObj, wndData, buttonRole) {
        wndData.modalResult = buttonRole;
        console.log(!!wndData.settings.isAutoClosing || !wndData.settings.hasOwnProperty('isAutoClosing'));
        console.log(wndData.settings.onClose);

        if (!!wndData.settings.isAutoClosing || !wndData.settings.hasOwnProperty('isAutoClosing')) {
          if (wndData.settings.onClose) {
            wndData.settings.onClose(wndObj, wndData.settings.userTag, wndData.modalResult);
          }

          wndObj.modal('hide');
        } // if (!!wndData.settings.isAutoClosing || wndData.settings.hasoisAutoClosing === undefined) {
        //     if (wndData.settings.onClose) {
        //         wndData.settings.onClose(wndObj, wndData.settings.userTag, wndData.modalResult);
        //     }
        //     wndObj.modal('hide');
        // }

      },
      forceCloseModal: function forceCloseModal(wndObj) {
        wndObj.modal('hide');
      }
    }
  };
}();

$(function () {
  if (!String.prototype.format) {
    String.prototype.format = function () {
      var args = arguments;
      var regrule = /{(\d+)}/g;

      if (args && args.length === 1 && _typeof(args[0]) === 'object') {
        args = args[0];
        regrule = /{([_a-zA-Z0-9]+)}/g;
      }

      return this.replace(regrule, function (match, number) {
        var t1 = args[number];
        return typeof args[number] !== 'undefined' ? args[number] : match;
      });
    };
  }

  if (!Date.prototype.withoutTime) {
    Date.prototype.withoutTime = function () {
      var d = new Date(this);
      d.setHours(0, 0, 0, 0);
      return d;
    };
  }

  if (!Date.prototype.format) {
    Date.prototype.format = function (mask, utc) {
      var date = this;
      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g;
      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
      var timezoneClip = /[^-+\dA-Z]/g;

      var pad = function pad(val, len) {
        val = String(val);
        len = len || 2;

        while (val.length < len) {
          val = "0".concat(val);
        }

        return val;
      };

      var masks = {
        "default": 'ddd mmm dd yyyy HH:MM:ss',
        shortDate: 'm/d/yy',
        mediumDate: 'mmm d, yyyy',
        longDate: 'mmmm d, yyyy',
        fullDate: 'dddd, mmmm d, yyy',
        shortTime: 'h:MM TT',
        mediumTime: 'h:MM:ss TT',
        longTime: 'h:MM:ss TT Z',
        isoDate: 'yyyy-mm-dd',
        isoTime: 'HH:MM:ss',
        isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
        isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
      };
      var i18n = {
        dayNames: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
        monthNames: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек', 'Январь', 'Февраль', 'Март', 'Фпрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
      }; // You can't provide utc if you skip other args (use the "UTC:" mask prefix)

      if (arguments.length === 1 && Object.prototype.toString.call(date) === '[object String]' && !/\d/.test(date)) {
        mask = date;
        date = undefined;
      } // Passing date through Date applies Date.parse, if necessary


      date = date ? new Date(date) : new Date();
      if (isNaN(date)) throw SyntaxError('invalid date');
      mask = String(masks[mask] || mask || masks["default"]); // Allow setting the utc argument via the mask

      if (mask.slice(0, 4) === 'UTC:') {
        mask = mask.slice(4);
        utc = true;
      }

      var _ = utc ? 'getUTC' : 'get';

      var d = date["".concat(_, "Date")]();
      var D = date["".concat(_, "Day")]();
      var m = date["".concat(_, "Month")]();
      var y = date["".concat(_, "FullYear")]();
      var H = date["".concat(_, "Hours")]();
      var M = date["".concat(_, "Minutes")]();
      var s = date["".concat(_, "Seconds")]();
      var L = date["".concat(_, "Milliseconds")]();
      var o = utc ? 0 : date.getTimezoneOffset();
      var flags = {
        d: d,
        dd: pad(d),
        ddd: i18n.dayNames[D],
        dddd: i18n.dayNames[D + 7],
        m: m + 1,
        mm: pad(m + 1),
        mmm: i18n.monthNames[m],
        mmmm: i18n.monthNames[m + 12],
        yy: String(y).slice(2),
        yyyy: y,
        h: H % 12 || 12,
        hh: pad(H % 12 || 12),
        H: H,
        HH: pad(H),
        M: M,
        MM: pad(M),
        s: s,
        ss: pad(s),
        l: pad(L, 3),
        L: pad(L > 99 ? Math.round(L / 10) : L),
        t: H < 12 ? 'a' : 'p',
        tt: H < 12 ? 'am' : 'pm',
        T: H < 12 ? 'A' : 'P',
        TT: H < 12 ? 'AM' : 'PM',
        Z: utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
        o: (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
        S: ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 !== 10) * d % 10]
      };
      return mask.replace(token, function ($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
      });
    };
  }
});

(function ($) {
  $.fn.showAsModal = function (method) {
    var funcs = {
      init: function init(options) {
        var settings = $.extend({
          // пользовательский объект, он пробрасывается во все обработчики событий.
          // Предназначен для хранения пользовательской инфы
          userTag: null,
          buttons: null,
          // массив отображаемых кнопок
          inputs: null,
          // массив отображаемых инпутов
          footer: null,
          // настройки футера
          title: '',
          // заголовок окна
          "class": '',
          // дополнительные классы
          isVertical: null,
          // является ли модалка вертикальной
          size: null,
          // размер модалки, пока доступны big, large
          isCelebrating: null,
          // является ли модалка красивой, поздравительной
          onOpen: null,
          // событие окно открывается function(sender, userTag)
          onClose: null,
          // событие окно закрывается function(sender, userTag, btnStatus)
          afterClose: null,
          // событие окно закрыто function(sender, userTag, btnStatus)
          isAutoClosing: true // автоматичесое закрытие модалки по нажатию на кнопки

        }, options);
        return this.each(function () {
          var $this = $(this);
          var wnd = modalDialog.showBaseWnd({
            title: settings.title,
            "class": settings["class"],
            userTag: {
              template: $this,
              templateParent: $this.parent(),
              settings: settings,
              needHide: false
            },
            buttons: settings.buttons,
            inputs: settings.inputs,
            isVertical: settings.isVertical,
            size: settings.size,
            footer: settings.footer,
            isCelebrating: settings.isCelebrating,
            isAutoClosing: settings.isAutoClosing,
            onOpen: function onOpen(sender, userTag) {
              var displ = userTag.template.css('display').toLowerCase();

              if (displ === 'none') {
                userTag.needHide = true;
                userTag.template.css('display', 'block');
              }

              if (userTag.settings.onOpen) {
                userTag.settings.onOpen($this, userTag.settings.userTag);
              }
            },
            afterOpen: function afterOpen(sender, userTag) {
              if (userTag.settings.afterOpen) {
                userTag.settings.afterOpen($this, userTag.settings.userTag);
              }
            },
            onClose: function onClose(sender, userTag, btnStatus) {
              if (userTag.settings.onClose) {
                userTag.settings.onClose($this, userTag.settings.userTag, btnStatus);
              }
            },
            afterClose: function afterClose(sender, userTag, btnStatus) {
              if (userTag.needHide) {
                userTag.template.css('display', 'none');
              }

              if (userTag.templateParent && userTag.templateParent.length > 0) {
                userTag.template.appendTo(userTag.templateParent);
              }

              if (userTag.settings.afterClose) {
                userTag.settings.afterClose($this, userTag.settings.userTag, btnStatus);
              } // стираем инфу об открытом окне


              sender.data(modalDialog.constants.dataKeys.userContainer, undefined);
            },
            onDrawContent: function onDrawContent(sender, userTag) {
              // сохраняем инфу об открытом окне
              $this.data(modalDialog.constants.dataKeys.userContainer, {
                wndObj: sender
              });
              return userTag.template;
            }
          });
        });
      }
    };
    var intFuncs = {};

    if (funcs[method]) {
      return funcs[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (_typeof(method) === 'object' || !method) {
      return funcs.init.apply(this, arguments);
    } else {
      $.error("\u041C\u0435\u0442\u043E\u0434 \u0441 \u0438\u043C\u0435\u043D\u0435\u043C ".concat(method, " \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u0434\u043B\u044F jQuery.showAsModal"));
    }
  };

  $.fn.modalDlgButtonDisabling = function (buttonRole, disabled) {
    var $this = $(this);
    var wndObj = $this.data(modalDialog.constants.dataKeys.userContainer) ? $this.data(modalDialog.constants.dataKeys.userContainer).wndObj : $this;
    modalDialog.tools.buttonsDisabling(wndObj, buttonRole, disabled);
  };

  $.fn.modalDlgClose = function (buttonRole) {
    var $this = $(this);
    var wndObj = $this.data(modalDialog.constants.dataKeys.userContainer) ? $this.data(modalDialog.constants.dataKeys.userContainer).wndObj : $this;
    modalDialog.tools.wndClose(wndObj, buttonRole);
  };

  $.fn.forceModalDlgClose = function (buttonRole) {
    var $this = $(this);
    var wndObj = $this.data(modalDialog.constants.dataKeys.userContainer) ? $this.data(modalDialog.constants.dataKeys.userContainer).wndObj : $this;
    modalDialog.tools.forceCloseModal(wndObj, buttonRole);
  };

  $.fn.setBusy = function (visible) {
    var $this = $(this);
    var indicator = $this.find('.partial-modal-loader');

    if (visible === undefined || !!visible && indicator.length === 0 || !visible && indicator.length > 0) {
      if (indicator.length > 0) {
        indicator.remove();
        indicator = null;
      } else {
        indicator = $('<div class="partial-modal-loader"></div>').appendTo($this);
      }
    }

    return indicator;
  };
})(jQuery);
/* eslint-enable */